var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',[_c('v-toolbar',{attrs:{"color":"secondary","flat":""}},[_c('v-toolbar-title',[_vm._v("Test Printer")]),_c('v-spacer')],1),_c('v-card-text',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-btn',{attrs:{"color":"accent"},on:{"click":_vm.testPrinter}},[_vm._v("Test Printer")])],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }